var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"vue-object-view-open",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }